export const FETCH_SINGLE_PAGE = 'FETCH_SINGLE_PAGE';
export const CREATE_SINGLE_PAGE = 'CREATE_SINGLE_PAGE';
export const UPDATE_SINGLE_PAGE = 'UPDATE_SINGLE_PAGE';